/* Laser Tag Set — brand interactions. Self-contained; does not touch Shrine's vendor JS. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- carousels: arrows (wrap-around), drag, counter ---------- */
  function initCarousel(root) {
    if (root.__lt) return; root.__lt = true;
    var track = root.querySelector('.lt-track');
    if (!track) return;
    var prev = root.querySelector('[data-lt-prev]');
    var next = root.querySelector('[data-lt-next]');
    var count = root.querySelector('[data-lt-count]');
    var items = Array.prototype.slice.call(track.children);
    function step() { var c = items[0]; if (!c) return track.clientWidth; var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16; return c.getBoundingClientRect().width + gap; }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 8; }
    function update() {
      if (!count) return;
      var i = Math.round(track.scrollLeft / step());
      var visible = Math.max(1, Math.round(track.clientWidth / step()));
      var last = Math.min(items.length, i + visible);
      count.textContent = String(i + 1).padStart(2, '0') + (last > i + 1 ? '–' + String(last).padStart(2, '0') : '') + ' / ' + String(items.length).padStart(2, '0');
    }
    if (next) next.addEventListener('click', function () { if (atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' }); else track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { if (track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); else track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
    // mouse drag (touch uses native scroll)
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) { moved = true; track.classList.add('is-drag'); } track.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      if (moved) { track.classList.remove('is-drag'); var s = step(); track.scrollTo({ left: Math.round(track.scrollLeft / s) * s, behavior: 'smooth' }); }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  /* ---------- buy buttons scroll to the buy box on the product page ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lt-buy]');
    if (!a) return;
    var info = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('product-form');
    if (info) {
      e.preventDefault();
      var y = info.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    }
  });

  /* ---------- lights out switch ---------- */
  function initLights(root) {
    if (root.__lt) return; root.__lt = true;
    var btn = root.querySelector('[data-lt-switch]');
    var touched = false;
    function set(dark) {
      root.classList.toggle('is-dark', dark);
      if (btn) btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
    }
    if (btn) btn.addEventListener('click', function () { touched = true; set(!root.classList.contains('is-dark')); });
    if ('IntersectionObserver' in window && root.hasAttribute('data-auto')) {
      var t;
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting && x.intersectionRatio > .45) { t = setTimeout(function () { if (!touched) { set(true); } io.disconnect(); }, 1800); }
          else clearTimeout(t);
        });
      }, { threshold: [0, .45, .7] });
      io.observe(root);
    }
  }

  /* ---------- arena map ---------- */
  function initMap(root) {
    if (root.__lt) return; root.__lt = true;
    function set(z) {
      root.querySelectorAll('[data-zone]').forEach(function (el) {
        var on = el.getAttribute('data-zone') === z;
        el.classList.toggle('is-on', on);
        if (el.tagName === 'BUTTON') el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-zone-panel]').forEach(function (el) { el.classList.toggle('is-on', el.getAttribute('data-zone-panel') === z); });
    }
    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-zone]');
      if (el && root.contains(el)) set(el.getAttribute('data-zone'));
    });
    root.addEventListener('keydown', function (e) {
      var el = e.target.closest && e.target.closest('[data-zone]');
      if (el && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); set(el.getAttribute('data-zone')); }
    });
  }

  /* ---------- hero: tap the arena to score ---------- */
  function initStage(root) {
    if (root.__lt) return; root.__lt = true;
    var p1 = root.querySelector('[data-p1]');
    var hint = root.querySelector('.lt-hero__hint');
    var hits = 0;
    root.addEventListener('click', function (e) {
      var r = root.getBoundingClientRect();
      var s = document.createElement('span');
      s.className = 'lt-shot';
      s.style.left = (e.clientX - r.left) + 'px';
      s.style.top = (e.clientY - r.top) + 'px';
      root.appendChild(s);
      setTimeout(function () { s.remove(); }, 700);
      hits++;
      if (p1) p1.textContent = String(3 + hits).padStart(2, '0');
      if (hint && hits === 1) hint.textContent = 'NICE SHOT · KEEP GOING';
      var art = root.querySelector('.lt-media');
      if (art && !reduce) { art.classList.remove('lt-anim'); void art.offsetWidth; art.classList.add('lt-anim'); }
    });
  }

  /* ---------- animate art only while visible ---------- */
  function initArtAnim() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { x.target.classList.toggle('lt-anim', x.isIntersecting); }); }, { threshold: .2 });
    document.querySelectorAll('[data-lt-art]').forEach(function (el) { io.observe(el); });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-lt-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-lt-lo]').forEach(initLights);
    scope.querySelectorAll('[data-lt-map]').forEach(initMap);
    scope.querySelectorAll('[data-lt-stage]').forEach(initStage);
    initArtAnim();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
